
import React from "react";
import "../styles/PartnersSlider.css";

import baptistAcademy from "../assets/partners/baptist-academy.png";
import blinkit from "../assets/partners/blinkit.png";
import blueezInformatic from "../assets/partners/bluez-informatic.png";
import eclerx from "../assets/partners/eclerx.png";
import gtam from "../assets/partners/gtam.png";
import hindusthanTrust from "../assets/partners/hindusthan-trust.png";
import karunya from "../assets/partners/karunya-deemed-university.png";
import kgisl from "../assets/partners/kgisl.png";
import kovai from "../assets/partners/kovai-co.png";
import learningLogics from "../assets/partners/learning-logics-academy.png";
import manfree from "../assets/partners/manfree.png";
import personiv from "../assets/partners/personiv.png";
import pumo from "../assets/partners/pumo-technovation.png";
import rathinam from "../assets/partners/rathinam.png";
import saraswathi from "../assets/partners/saraswathi-ramachandran-vidyalaya.png";
import snr from "../assets/partners/snr-sons-trust.png";
import srec from "../assets/partners/srec.png";
import sriRamakrishna from "../assets/partners/sri-ramakrishna-college.png";
import sriVinayaga from "../assets/partners/sri-vinayaga-vidyalaya.png";
import tata from "../assets/partners/tata.png";
import thamarai from "../assets/partners/thamarai-world-school.png";
import vit from "../assets/partners/vit-chennai.png";
import immaculateLogo from "../assets/partners/immaculate-cbse.png";
import skarRoboticsLogo from "../assets/partners/skar-robotics.png";
const logos = [
  { name: "Baptist Academy", src: baptistAcademy },
  { name: "Blinkit", src: blinkit },
  { name: "Blueez Informatic", src: blueezInformatic },
  { name: "eClerx", src: eclerx },
  { name: "GTAM", src: gtam },
  { name: "Hindusthan Trust", src: hindusthanTrust },
  { name: "Karunya", src: karunya },
  { name: "KGiSL", src: kgisl },
  { name: "Kovai", src: kovai },
  { name: "Learning Logics", src: learningLogics },
  { name: "Manfree", src: manfree },
  { name: "Personiv", src: personiv },
  { name: "PUMO Technovation", src: pumo },
  { name: "Rathinam", src: rathinam },
  { name: "Saraswathi Ramachandran", src: saraswathi },
  { name: "SNR Sons Trust", src: snr },
  { name: "SREC", src: srec },
  { name: "Sri Ramakrishna", src: sriRamakrishna },
  { name: "Sri Vinayaga Vidyalaya", src: sriVinayaga },
  { name: "Tata", src: tata },
  { name: "Thaamarai World School", src: thamarai },
  { name: "VIT Chennai", src: vit },
  { name: "Immaculate CBSE", src: immaculateLogo },
  { name: "SKAR Robotics", src: skarRoboticsLogo },
];

export default function PartnersSlider() {
  return (
    <section
  className="partners-section"
  aria-label="Our Innovation Network"
>
      <h2 className="partners-heading">Our Innovation Network</h2>
      <div className="partners-marquee">
        <div className="partners-track">
          {[0, 1].map((copy) => (
            <div
              className="partners-group"
              key={copy}
              aria-hidden={copy === 1 ? "true" : undefined}
            >
              {logos.map((logo) => (
                <div
                  className="partners-logo"
                  key={`${copy}-${logo.name}`}
                >
                  <img
                    src={logo.src}
                    alt={copy === 0 ? logo.name : ""}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
